import { jsxs, jsx } from "react/jsx-runtime";
import { Box } from "@zillow/constellation-10";
import { useState, useEffect } from "react";
import { omitUndefined } from "../../utils/lodash.esm.js";
import MortgagePageClassification from "../../utils/mortgagehelpers/MortgagePageClassification.esm.js";
import CalculatorForm from "../CalculatorForm/CalculatorForm.esm.js";
import LegalDisclosuresModal from "../LegalDisclosuresModal/LegalDisclosuresModal.esm.js";
import { getMortgageRates } from "../LegalDisclosuresModal/constants.esm.js";
import { OPTIONS_TIMESPAN, OPTIONS_LTV, CREDIT_SCORE_BUCKETS, OPTIONS_LOAN_TYPE, FieldConfig } from "./MortgageRateTrends.utils.esm.js";
import MortgageRateTrendsChart from "./MortgageRateTrendsChart.esm.js";
import MortgageRateTrendsFields from "./MortgageRateTrendsFields.esm.js";
const MortgageRateTrends = ({
  defaultValues,
  editorMode,
  pathName
}) => {
  const classification = new MortgagePageClassification(pathName ? pathName : "/mortgage-rates/");
  const [rates, setRates] = useState({});
  const finalDefaultValues = {
    // Default values
    [FieldConfig.loanPurpose.name]: OPTIONS_LOAN_TYPE.Purchase,
    [FieldConfig.creditRating.name]: CREDIT_SCORE_BUCKETS.VeryHigh,
    [FieldConfig.Fixed30Year.name]: true,
    [FieldConfig.location.name]: "United States",
    [FieldConfig.percentDown.name]: OPTIONS_LTV.Normal,
    [FieldConfig.timeSpan.name]: OPTIONS_TIMESPAN.OneYear,
    // Custom default values
    ...omitUndefined(defaultValues)
  };
  useEffect(() => {
    const fetchRates = async () => {
      try {
        const response = await getMortgageRates(pathName);
        setRates(response);
      } catch (error) {
        console.error("Error fetching mortgage rates:", error);
      }
    };
    fetchRates();
  }, [pathName]);
  return /* @__PURE__ */ jsxs(CalculatorForm, { fieldStorageKey: "mortgageratetrendsfields", defaultValues: finalDefaultValues, editorMode, children: [
    /* @__PURE__ */ jsxs(Box, { css: {
      display: "flex",
      flexDirection: {
        base: "column",
        xxl: "row"
      }
    }, children: [
      /* @__PURE__ */ jsx(Box, { css: {
        marginRight: {
          xxl: "tighter"
        },
        order: {
          base: 2,
          xxl: 1
        }
      }, children: /* @__PURE__ */ jsx(MortgageRateTrendsFields, {}) }),
      /* @__PURE__ */ jsx(Box, { asChild: true, css: {
        flex: "1",
        order: {
          base: 1,
          xxl: 2
        },
        // v8 <Flex as="figure"> left browser UA margins (~16px block, 40px inline).
        marginBlock: "default",
        marginInline: "{spacing.1000}"
      }, children: /* @__PURE__ */ jsx("figure", { tabIndex: 0, role: "group", children: /* @__PURE__ */ jsx(MortgageRateTrendsChart, {}) }) })
    ] }),
    /* @__PURE__ */ jsx(Box, { css: {
      marginTop: "default"
    }, children: /* @__PURE__ */ jsx(LegalDisclosuresModal, { classification, rates }) })
  ] });
};
export {
  MortgageRateTrends as default
};
